import {
	getCustomTableFieldsResolved,
	getProximityAttributeFields,
	getProximityAttributeFieldsRejected,
	getProximityAttributeFieldsResolved,
} from '@Actions';
import {
	clearAssetFields,
	getAssetFields,
	getAssetFieldsRejected,
	getAssetFieldsResolved,
	getAssetFilterList,
	getAssetFilterListRejected,
	getAssetFilterListResolved,
	getSpatialLayerList,
	getSpatialLayerListRejected,
	getSpatialLayerListResolved,
} from '@Actions/asset.actions';
import { createReducer } from '@reduxjs/toolkit';
import { AssetStoreState } from '@Types';
import { AnyAction } from 'redux';

export const initState: AssetStoreState = {
	assetFields: [],
	assetFilters: [],
	isLoading: false,
	spatialLayerList: [],
	spatialLayerListLoaded: false,
	spatialProximityAttr: [],
	spatialProximityAttrLoaded: false,
	customTable: [],
};

interface AssetReducer {
	[x: string]: (
		state: AssetStoreState,
		action: AnyAction,
	) => AssetStoreState | undefined;
}

export const reducer: AssetReducer = {
	[getAssetFields.toString()]: state => ({
		...state,
		isLoading: true,
	}),
	[getAssetFieldsResolved.toString()]: (state, action) => ({
		...state,
		assetFields: action.payload,
		isLoading: false,
	}),
	[getAssetFieldsRejected.toString()]: state => ({
		...state,
		isLoading: false,
	}),
	[clearAssetFields.toString()]: state => ({
		...state,
		assetFields: [],
	}),
	[getAssetFilterList.toString()]: state => ({
		...state,
		isLoading: true,
	}),
	[getAssetFilterListResolved.toString()]: (state, action) => ({
		...state,
		assetFilters: action.payload,
		isLoading: false,
	}),
	[getAssetFilterListRejected.toString()]: state => ({
		...state,
		isLoading: false,
	}),
	[getSpatialLayerList.toString()]: state => ({
		...state,
		spatialLayerListLoaded: false,
	}),
	[getSpatialLayerListResolved.toString()]: (state, action) => ({
		...state,
		spatialLayerList: action.payload,
		spatialLayerListLoaded: true,
	}),
	[getSpatialLayerListRejected.toString()]: state => ({
		...state,
		spatialLayerListLoaded: false,
	}),
	[getProximityAttributeFields.toString()]: state => ({
		...state,
		spatialProximityAttrLoaded: false,
	}),
	[getProximityAttributeFieldsResolved.toString()]: (state, action) => ({
		...state,
		spatialProximityAttr: action.payload,
		spatialProximityAttrLoaded: true,
	}),
	[getProximityAttributeFieldsRejected.toString()]: state => ({
		...state,
		spatialProximityAttrLoaded: false,
	}),
	[getCustomTableFieldsResolved.toString()]: (state, action) => ({
		...state,
		customTable: action.payload,
	}),
};

export const assetReducer = createReducer(initState, reducer);
